//React
//Components
import {
  AlphaNumericInput,
  Button,
  CalendlyModal,
  Card,
  Dropdown,
  EmailModal,
  EmailRegistrationModal,
  FlexBox,
  Input,
  Screen,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import {
  registerClientApi,
  registerTechTeamApi,
  setGeneralDetails,
  useGeneralDetails,
  useRegisterClientApiDetails,
} from "Slices";
//Utils
import {
  ChangeHistory,
  EventManager,
  EventNames,
  getURLParameter,
  history,
  useIsInViewport,
  validateEmail,
} from "utils";
//Styles
import "./styles.scss";
//Assets
import MobileImg from "assets/mobile-image.png";
import LandingImg from "assets/landing-image.svg";
import SecurityCheckImg from "assets/security-check.svg";
import CrossIcon from "assets/icons/cross.svg";
import ProfileIcon from "assets/icons/profile.svg";
import WhatsappIcon from "assets/icons/whatsapp.svg";
import RightArrowIcon from "assets/icons/right-arrow.svg";
import FreeForeverIcon from "assets/icons/Free forever.svg";
import FrictionlessLoginIcon from "assets/icons/Frictionless Login.svg";
import PreventAccountTakeoversIcon from "assets/icons/Prevent account takeovers.svg";
import JavaIcon from "assets/icons/java.png";
import AndroidIcon from "assets/icons/android.svg";
import AppleIcon from "assets/icons/apple.svg";
import RestApiIcon from "assets/icons/rest-api.svg";
import FlutterIcon from "assets/icons/flutter.png";
import IntegrationBackgroundImg from "assets/integratin elements.svg";
import BharatPeLogo from "assets/company logos/bharatpe.svg";
import BillBookLogo from "assets/company logos/billbook.svg";
import DstreetLogo from "assets/company logos/dstreet-finance-logo-white.svg";
import ElectricpeLogo from "assets/company logos/electricpe.svg";
import RiveLogo from "assets/company logos/rive-temp-logo.svg";
import SecureNowLogo from "assets/company logos/secure now.png";
import StraightLineLogo from "assets/company logos/Straight-Line-Logo-Blue.svg";
import ZtockLogo from "assets/company logos/ztocks-logo.png";
import PostPeLogo from "assets/company logos/postpe.svg";
import ParkLogo from "assets/company logos/park.svg";
import CapriLogo from "assets/company logos/capri.svg";
import CootzLogo from "assets/company logos/cootz.svg";
import SayFLogo from "assets/company logos/sayf.svg";
import TrustLogo from "assets/trust-logo.svg";
import VideoThumbnail from "assets/video-thumbnail.jpg";
import ShadowImg from "assets/shadow.svg";
//Library
import Slider from "react-slick";
import cx from "classnames";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import NewLanding from "containers/NewLanding";

const Landing = () => {
  //Dispatch
  const dispatch = useDispatch();

  //Selectors
  const registerClientDetails = useRegisterClientApiDetails();

  //Constants
  const [lang, setLang] = useState("Javascript");
  const [email, setEmail] = useState("");
  const [
    emailRegistrationModalVisibility,
    setEmailRegistrationModalVisibility,
  ] = useState(false);
  const [emailInitiateModalVisibility, setEmailInitiateModalVisibility] =
    useState(false);
  const [calendlyModalVisibility, setcalendlyModalVisibility] = useState(false);
  const [videoSectionVisibility, setVideoSectionVisibility] = useState(false);
  const [inputAutoFocus, setInputAutoFocus] = useState(false);
  const [userRegistered, setUserRegistered] = useState(false);
  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  const [fullscreenVideoVisibility, setFullscreenVideoVisibility] =
    useState(false);
  const [stopHasslingSectionVisibility, setStopHasslingSectionVisibility] =
    useState(false);
  const [integrationSectionVisibility, setIntegrationSectionVisibility] =
    useState(false);
  const [trustedByUsersSectionVisibility, setTrustedByUsersSectionVisibility] =
    useState(false);
  const [testimonialSectionVisibility, setTestimonialSectionVisibility] =
    useState(false);
  const stopHasslingSectionRef: any = useRef(null);
  const videoSectionRef: any = useRef(null);
  const integrationSectionRef: any = useRef(null);
  const trustedByUsersSectionRef: any = useRef(null);
  const testimonialSectionRef: any = useRef(null);
  const WelcomeSectionRef: any = useRef();
  const generalDetails: any = useGeneralDetails();

  //useEffects
  useEffect(() => {
    window.addEventListener("scroll", onScroll, true);
    EventManager.send(EventNames.EVENTS_NAME.WEBSITE.HOME_PAGE.PAGE_VIEW);
    if (getURLParameter("context") === "registerTechTeam") {
      setEmailInitiateModalVisibility(true);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  useEffect(() => {
    setUserRegistered(
      registerClientDetails?.data?.status === "SUCCESS" &&
        !registerClientDetails?.data?.isExist
    );
    if (
      registerClientDetails?.data?.status === "SUCCESS" &&
      registerClientDetails?.data?.isExist
    ) {
      const endPath = window.localStorage.getItem("token")
        ? "ACTIVITY"
        : "SIGNUP_LOGIN";

      ChangeHistory("push", ROUTE_PATH.DASHBOARD[endPath]);
    }
  }, [registerClientDetails]);

  const [goOTPLessClicked, setGoOTPLessClicked] = useState(false);

  const onScroll = (event: any) => {
    const docViewTop = window.pageYOffset;
    const stopHasslingSectionTop =
      stopHasslingSectionRef?.current?.offsetTop - 800;
    const GoOTPLessClickedTop =
      stopHasslingSectionRef?.current?.offsetTop - 100;
    const videoSectionTop = videoSectionRef?.current?.offsetTop - 800;
    const integrationSectionTop =
      integrationSectionRef?.current?.offsetTop - 800;
    const trustedByUsersSectionTop =
      trustedByUsersSectionRef?.current?.offsetTop - 800;
    const testimonialSectionTop =
      testimonialSectionRef?.current?.offsetTop - 800;
    if (
      docViewTop >= stopHasslingSectionTop &&
      !stopHasslingSectionVisibility
    ) {
      setStopHasslingSectionVisibility(true);
    }
    // if (docViewTop >= GoOTPLessClickedTop) {
    //   setGoOTPLessClicked(false);
    // }
    if (docViewTop >= videoSectionTop && !videoSectionVisibility) {
      setVideoSectionVisibility(true);
    }
    if (docViewTop >= integrationSectionTop && !integrationSectionVisibility) {
      setIntegrationSectionVisibility(true);
    }
    if (
      docViewTop >= trustedByUsersSectionTop &&
      !trustedByUsersSectionVisibility
    ) {
      setTrustedByUsersSectionVisibility(true);
    }
    if (docViewTop >= testimonialSectionTop && !testimonialSectionVisibility) {
      setTestimonialSectionVisibility(true);
    }
  };

  const registerClient = () => {
    if (validateEmail(email)) {
      setGeneralDetails({
        email,
      });
      dispatch(
        registerClientApi({
          email,
        })
      );
    } else {
      toast.error("Please enter your work email.");
    }
  };

  const disableScrolling = () => {
    var x = window.scrollX;
    var y = window.scrollY;
    window.onscroll = function () {
      window.scrollTo(x, y);
    };
  };

  const enableScrolling = () => {
    window.onscroll = function () {};
  };

  const FirstSection = (
    <FlexBox
      justifyBetween
      alignCenter
      className={cx(
        window.screen.width > 968 && "mr-t-50",
        "pd-h-60 desktop-mobile"
      )}
    >
      {/* {FirstSection} */}
      <div className="w-50 pd-v-30 animated fadeInLeft">
        <FlexBox alignCenter className="fs-44 font-heavy clr-dark">
          Add{" "}
          <Button
            variant="outline clr-black"
            text={
              <FlexBox alignCenter justifyCenter>
                <Image src={WhatsappIcon} className="w-10 mr-r-10" />
                <p className="no-wrap clr-theme">Login with WhatsApp</p>
              </FlexBox>
            }
            className="mr-l-20 fs-18 whatsapp-button"
            disabled
          />
        </FlexBox>
        <p className="fs-44 font-heavy clr-dark mr-t-10">
          button to your app or website.{" "}
        </p>
        <p className="fs-44 font-heavy clr-theme mr-b-10">Free Forever !!</p>
        {/* <Button
            rounded
            text={
              <FlexBox alignCenter justifyCenter>
                <p className="fs-20 clr-white">Go Live</p>
                <Image
                  src={RightArrowIcon}
                  className={cx("w-8 mr-h-10 arrow-animation")}
                />
              </FlexBox>
            }
            className={cx(goOTPLessClicked && "get-api-button-hidden", "get-api-button fs-16 w-50 mr-t-20 desktop-button")}
            onClick={() => {
              setGoOTPLessClicked(true);
              window.addEventListener("scroll", onScroll, true);
            }}
          /> */}
        <Button
          text={
            <FlexBox alignCenter justifyCenter>
              <p className="fs-20 clr-white">Go Live</p>
              <Image
                src={RightArrowIcon}
                className={cx("mr-h-10 arrow-animation")}
              />
            </FlexBox>
          }
          className={cx("br-60 clr-white no-wrap mr-t-20 fs-20 go-otpless987")}
          onClick={() => {
            EventManager.send(
              EventNames.EVENTS_NAME.WEBSITE.HOME_PAGE.TOP_GO_OTPLESS_CLICK
            );
            setEmailInitiateModalVisibility(true);
          }}
        />
      </div>
      <div className="w-50 landing-img-div text-center animated fadeInRight">
        <Image src={LandingImg} className="w-100 landing-img" />
      </div>
    </FlexBox>
  );

  const BottomSection = (
    <>
      {/* Second Section */}
      <div
        className={cx(
          getURLParameter("version") === "v3" && "v3-pad",
          "stop-hassling pd-t-40 pd-b-50 pd-h-60 desktop-mobile"
        )}
        ref={stopHasslingSectionRef}
      >
        <h2 className={cx(getURLParameter("version") === "v3" && "dsp-n")}>
          <p className="clr-dark font-heavy text-center fs-36">
            Stop Hassling your users with{" "}
            <span className="clr-theme">OTPs</span>
          </p>
          <p className="clr-dark font-heavy text-center fs-28 mr-t-20">
            Go <span className="clr-theme">OTPless</span>
          </p>
        </h2>
        <FlexBox justifyBetween className="mr-t-40 row-cards">
          {stopHasslingSectionVisibility && (
            <>
              <Card className="w-30 h-au animated fadeInLeft">
                <div className="img-div">
                  <Image src={FrictionlessLoginIcon} className="w-20" />
                </div>
                <FlexBox className="title">
                  <h3 className="font-heavy fs-18">2-Tap Login Experience</h3>
                </FlexBox>
                <FlexBox className="content">
                  <h4 className="fs-14">
                    Resulting in{" "}
                    <span className="clr-theme font-heavy">
                      lower drop-offs
                    </span>{" "}
                    & <span className="clr-theme font-heavy">Higher NPS</span>{" "}
                  </h4>
                </FlexBox>
              </Card>
              <Card className="w-30 h-au animated fadeInLeft delay-01s">
                <div className="img-div">
                  <Image src={FreeForeverIcon} className="w-25" />
                </div>
                <FlexBox className="title">
                  <h3 className="font-heavy fs-18">Free Forever</h3>
                </FlexBox>
                <FlexBox className="content">
                  <h4 className="fs-14">
                    Bring your SMS{" "}
                    <span className="clr-theme font-heavy">OTP</span> costs to{" "}
                    <span className="clr-theme font-heavy">zero</span>
                  </h4>
                </FlexBox>
              </Card>
              <Card className="w-30 h-au animated fadeInLeft delay-02s">
                <div className="img-div">
                  <Image src={PreventAccountTakeoversIcon} className="w-25" />
                </div>
                <FlexBox className="title">
                  <h3 className="font-heavy fs-18">
                    Prevent Account Takeovers
                  </h3>
                </FlexBox>
                <FlexBox className="content">
                  <h4 className="fs-14">
                    Enhance{" "}
                    <span className="clr-theme font-heavy">
                      trust and safety
                    </span>{" "}
                    with WhatsApp’s End to End Encryption.
                  </h4>
                </FlexBox>
              </Card>
            </>
          )}
        </FlexBox>
      </div>
      {/* Third Section */}
      <FlexBox
        justifyBetween
        alignCenter
        className="video-section pd-h-60 pd-t-40 pd-b-50"
        flexBoxRef={videoSectionRef}
      >
        <Card
          className={cx("video pd-0 w-50 animated fadeInUp delay-01s pos-rel")}
        >
          <Image src={VideoThumbnail} className="h-100 w-100 thumbnail" />
          <FlexBox
            justifyCenter
            alignCenter
            className="play-background"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.HOME_PAGE.VIDEO_CLICK
              );
              disableScrolling();
              setFullscreenVideoVisibility(true);
            }}
          >
            <div className="play-button"></div>
          </FlexBox>
          {fullscreenVideoVisibility && (
            <FlexBox
              justifyCenter
              alignCenter
              className="iframe-div animated zoomIn"
            >
              <Image
                src={CrossIcon}
                className="cross-icon curs-point"
                onClick={() => {
                  enableScrolling();
                  setFullscreenVideoVisibility(false);
                }}
              />
              <iframe
                src="https://player.vimeo.com/video/745277742?h=d36f4b2710&amp;badge=0&amp;autopause=0&amp;autoplay=1&amp;loop=1&amp;player_id=0&amp;app_id=58479"
                // frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                // style="position:absolute;top:0;left:0;width:100%;height:100%;"
                title="login with whatsapp.mp4"
                className="w-100 h-100 no-border"
              />
            </FlexBox>
          )}
        </Card>
        <div className="w-45">
          <h2 className="clr-dark font-heavy fs-32 animated fadeInUp delay-01s">
            Watch it in Action
          </h2>
          <h3 className="fs-16 mr-v-40 animated fadeInUp delay-03s">
            Compare <span className="font-heavy">"Login with WhatsApp"</span>{" "}
            experience with your existing SMS-OTP Login
          </h3>
          <Button
            text={
              <FlexBox alignCenter justifyCenter>
                <p className="fs-20 clr-white">Go Live</p>
                <Image
                  src={RightArrowIcon}
                  className={cx("mr-h-10 arrow-animation")}
                />
              </FlexBox>
            }
            className={cx(
              "br-60 clr-white no-wrap mr-t-20 fs-20 go-otpless987"
            )}
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.HOME_PAGE.VIDEO_GO_OTPLESS_CLICK
              );
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
              setTimeout(() => {
                setInputAutoFocus(true);
              }, 1000);
              // setEmailInitiateModalVisibility(true);
            }}
          />
          {/* <Button
                text={"Go Live"}
                className="fs-18 w-60 animated fadeInUp delay-05s"
              /> */}
        </div>
      </FlexBox>
      {/* Fourth Section */}
      <div
        className="integrations pd-h-60 text-center pd-v-40"
        ref={integrationSectionRef}
      >
        {integrationSectionVisibility && (
          <>
            <h2 className="clr-dark font-heavy text-center fs-36 animated fadeInUp delay-01s">
              Fast SDK integration & easy-to-use APIs
            </h2>

            <h3 className="clr-dark font-heavy text-center fs-24 animated fadeInUp delay-03s mr-t-10 clr-theme">
              Designed for Developers
            </h3>
            <FlexBox justifyBetween className="mr-t-60 integration-flexbox">
              <Card className="pd-0 animated fadeInLeft delay-05s">
                <div className="pd-20 border-bottom">
                  <Image src={RestApiIcon} />
                  <h4 className="mr-t-40 fs-20 font-heavy">Rest API</h4>
                </div>
                <Button
                  variant="no-outline no-shadow pd-v-20 clr-black"
                  text={"View Document"}
                  onClick={() => {
                    EventManager.send(
                      EventNames.EVENTS_NAME.WEBSITE.HOME_PAGE.REST_API_CLICK
                    );
                    ChangeHistory("push", ROUTE_PATH.DOCS.API_REFERENCE);
                  }}
                />
              </Card>
              <Card className="pd-0 animated fadeInLeft delay-03s">
                <div className="pd-20 border-bottom">
                  <Image src={AndroidIcon} />
                  <h4 className="mr-t-40 fs-20 font-heavy">Android</h4>
                </div>
                <Button
                  variant="no-outline no-shadow pd-v-20 clr-black"
                  text={"View Document"}
                  onClick={() => {
                    EventManager.send(
                      EventNames.EVENTS_NAME.WEBSITE.HOME_PAGE.ANDROID_CLICK
                    );
                    ChangeHistory("push", ROUTE_PATH.DOCS.SDK.ANDROID);
                  }}
                />
              </Card>
              <Card className="pd-0 animated fadeInLeft delay-05s">
                <div className="pd-20 border-bottom">
                  <Image src={AppleIcon} />
                  <h4 className="mr-t-40 fs-20 font-heavy">iOS</h4>
                </div>
                <Button
                  variant="no-outline no-shadow pd-v-20 clr-black"
                  text={"View Document"}
                  onClick={() => {
                    EventManager.send(
                      EventNames.EVENTS_NAME.WEBSITE.HOME_PAGE.IOS_CLICK
                    );
                    ChangeHistory("push", ROUTE_PATH.DOCS.SDK.IOS);
                  }}
                />
              </Card>
              <Card className="pd-0 animated fadeInLeft delay-01s">
                <div className="pd-20 border-bottom">
                  <Image src={JavaIcon} />
                  <h4 className="mr-t-40 fs-20 font-heavy">Javascript</h4>
                </div>
                <Button
                  variant="no-outline no-shadow pd-v-20 clr-black"
                  text={"View Document"}
                  onClick={() => {
                    EventManager.send(
                      EventNames.EVENTS_NAME.WEBSITE.HOME_PAGE.JAVASCRIPT_CLICK
                    );
                    ChangeHistory("push", ROUTE_PATH.DOCS.SDK.JAVASCRIPT);
                  }}
                />
              </Card>
              <Card className="pd-0 animated fadeInLeft delay-01s">
                <div className="pd-20 border-bottom">
                  <Image src={FlutterIcon} />
                  <h4 className="mr-t-40 fs-20 font-heavy">Flutter</h4>
                </div>
                <Button
                  variant="no-outline no-shadow pd-v-20 clr-black"
                  text={"View Document"}
                  onClick={() => {
                    EventManager.send(
                      EventNames.EVENTS_NAME.WEBSITE.HOME_PAGE.FLUTTER_CLICK
                    );
                    ChangeHistory("push", ROUTE_PATH.DOCS.SDK.FLUTTER);
                  }}
                />
              </Card>
            </FlexBox>
          </>
        )}
      </div>
      {/* Fifth Section */}
      <div
        className="trusted-enterprises pd-t-40 pd-b-50 pd-h-60 desktop-mobile"
        ref={trustedByUsersSectionRef}
      >
        {trustedByUsersSectionVisibility && (
          <>
            <FlexBox
              justifyBetween
              alignTop
              className="mr-v-40 animated fadeInUp delay-03s landing-counts"
            >
              <div className="w-33 text-center">
                <p className="fs-36 font-heavy clr-theme">5.5M+</p>
                <h5 className="fs-18 font-medium">Users Authenticated</h5>
              </div>
              <div className="w-33 text-center">
                <p className="fs-36 font-heavy clr-theme">26% &#8593;</p>
                <h5 className="fs-18 font-medium">Login Conversion</h5>
              </div>
              <div className="w-33 text-center">
                <p className="fs-36 font-heavy clr-theme">0</p>
                <h5 className="fs-18 font-medium">Security Incidence</h5>
              </div>
            </FlexBox>
            <h2 className="clr-dark font-heavy text-center fs-36 animated fadeInUp delay-01s mr-t-100">
              Trusted by <span className="clr-theme">Enterprises</span>
            </h2>
            {/* <Slider
              dots={false}
              speed={500}
              className={
                "center mr-t-40 pd-t-40 animated fadeInRight delay-03s"
              }
              adaptiveHeight={true}
              infinite={true}
              initialSlide={0}
              slidesToShow={window.screen.width < 968 ? 1 : 4}
              autoplay={true}
              pauseOnHover={false}
            > */}
            <div className="marquee">
              <div className="track">
                <Image src={BharatPeLogo} className="mr-h-30" />
                <Image src={BillBookLogo} className="mr-h-30" />
                <Image src={DstreetLogo} className="mr-h-30" />
                <Image src={ElectricpeLogo} className="mr-h-30" />
                <Image src={RiveLogo} className="mr-h-30" />
                <Image src={SecureNowLogo} className="mr-h-30" />
                <Image src={StraightLineLogo} className="mr-h-30" />
                <Image src={ZtockLogo} className="mr-h-30" />
                <Image src={PostPeLogo} className="mr-h-30" />
                <Image src={ParkLogo} className="mr-h-30" />
                <Image src={CapriLogo} className="mr-h-30" />
                <Image src={CootzLogo} className="mr-h-30" />
                <Image src={SayFLogo} className="mr-h-30 sayf-logo" />
                <Image src={BharatPeLogo} className="mr-h-30" />
                <Image src={BillBookLogo} className="mr-h-30" />
                <Image src={DstreetLogo} className="mr-h-30" />
                <Image src={ElectricpeLogo} className="mr-h-30" />
                <Image src={RiveLogo} className="mr-h-30" />
                <Image src={SecureNowLogo} className="mr-h-30" />
                <Image src={StraightLineLogo} className="mr-h-30" />
                <Image src={ZtockLogo} className="mr-h-30" />
                <Image src={PostPeLogo} className="mr-h-30" />
                <Image src={ParkLogo} className="mr-h-30" />
                <Image src={CapriLogo} className="mr-h-30" />
                <Image src={CootzLogo} className="mr-h-30" />
                <Image src={SayFLogo} className="mr-h-30 sayf-logo" />
              </div>
            </div>
            {/* </Slider> */}
          </>
        )}
      </div>
      {/* Sixth Section */}
      <div
        className="testimonial mr-t-40 pd-h-60 pd-v-20"
        ref={testimonialSectionRef}
      >
        {testimonialSectionVisibility && (
          <>
            <h2 className="clr-dark font-heavy text-center fs-36 animated fadeInUp delay-01s">
              Here’s why enterprises trust{" "}
              <span className="clr-theme">OTPless</span>
            </h2>
            <div className="mr-t-40 pd-t-20 shadow-div pos-rel animated fadeInRight delay-03s">
              <Image src={ShadowImg} className="left-shadow-img" />
              <Image src={ShadowImg} className="right-shadow-img" />
              <Slider
                dots={true}
                speed={2000}
                className={"center"}
                centerMode={window.screen.width > 968}
                adaptiveHeight={false}
                infinite={true}
                arrows={window.screen.width < 968}
                initialSlide={0}
                autoplay={false}
                pauseOnHover={true}
              >
                <Card className="text-left" key={`recent-activity-${"m"}-${1}`}>
                  <FlexBox flexColumn justifyBetween className="h-100">
                    <Image src={BharatPeLogo} className="company-logo" />
                    <h4 className="mr-v-40 fs-16">
                      We were looking for a more secure and user friendly ‘Login
                      with Phone Number’ solution when we found OTPless' ‘Login
                      with WhatsApp’ button. This, not only gave us the peace of
                      mind with the user initiated 2FA login solution but also
                      gave us a 25% increased conversion rate.
                    </h4>
                    <FlexBox alignCenter>
                      <Image src={ProfileIcon} className="user-logo" />
                      <div className="mr-l-20">
                        <h5 className="font-heavy">Ankur Jain</h5>
                        <h6 className="fs-14 clr-theme font-medium">
                          Chief Product Officer, BharatPe
                        </h6>
                      </div>
                    </FlexBox>
                  </FlexBox>
                </Card>
                <Card className="text-left" key={`recent-activity-${"m"}-${2}`}>
                  <FlexBox flexColumn justifyBetween className="h-100">
                    <Image src={CapriLogo} className="company-logo" />
                    <h4 className="mr-v-40 fs-16">
                      No other solution solves the authentication issues as
                      OTPless. It has helped us solve 2 long-tail problems of
                      customer onboarding and engagement. We now seamlessly
                      onboard our customers and also continue to engage them on
                      a high-fidelity platform in just one step
                    </h4>
                    <FlexBox alignCenter>
                      <Image src={ProfileIcon} className="user-logo" />
                      <div className="mr-l-20">
                        <h5 className="font-heavy">Varun Malhotra</h5>
                        <h6 className="fs-14 clr-theme font-medium">
                          SVP of Technology, Capri Global Capital Ltd.
                        </h6>
                      </div>
                    </FlexBox>
                  </FlexBox>
                </Card>
                <Card className="text-left" key={`recent-activity-${"m"}-${3}`}>
                  <FlexBox flexColumn justifyBetween className="h-100">
                    <Image src={SayFLogo} className="company-logo small" />
                    <h4 className="mr-v-40 fs-16">
                      I have been completely surprised seeing how seamless,
                      secure & fast the login process with OTPless is.
                    </h4>
                    <p className="mr-v-20"></p>
                    <FlexBox alignCenter>
                      <Image src={ProfileIcon} className="user-logo" />
                      <div className="mr-l-20">
                        <h5 className="font-heavy">Aman Singh</h5>
                        <h6 className="fs-14 clr-theme font-medium">
                          Co-Founder, SayF
                        </h6>
                      </div>
                    </FlexBox>
                  </FlexBox>
                </Card>
              </Slider>
            </div>
            <Button
              text={
                <FlexBox alignCenter justifyCenter>
                  <p className="fs-20 clr-white">Go Live</p>
                  <Image
                    src={RightArrowIcon}
                    className={cx("mr-h-10 arrow-animation")}
                  />
                </FlexBox>
              }
              className={cx(
                "br-60 clr-white no-wrap mr-t-20 fs-20 go-otpless987 center-action"
              )}
              onClick={() => {
                EventManager.send(
                  EventNames.EVENTS_NAME.WEBSITE.HOME_PAGE
                    .BOTTOM_GO_OTPLESS_CLICK
                );
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
                setTimeout(() => {
                  setInputAutoFocus(true);
                }, 1000);
                // setEmailInitiateModalVisibility(true);
              }}
            />
          </>
        )}
      </div>
    </>
  );

  //Return UI
  return (
    <>
      <Screen
        className={cx("website-landing-screen pd-t-80")}
        screenAnimationClass="no-animation"
      >
        <div ref={WelcomeSectionRef}>
          <NewLanding
            knowMoreAction={() => {
              stopHasslingSectionRef?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              });
            }}
            inputAutoFocus={inputAutoFocus}
          />
        </div>
        <EmailRegistrationModal
          visible={emailRegistrationModalVisibility}
          onClose={() => setEmailRegistrationModalVisibility(false)}
        />
        <CalendlyModal
          visible={calendlyModalVisibility}
          onClose={() => setcalendlyModalVisibility(false)}
        />
        <EmailModal
          visible={emailInitiateModalVisibility}
          onClose={() => {
            setEmailInitiateModalVisibility(false);
            ChangeHistory("push", ROUTE_PATH.DASHBOARD.SIGNUP_LOGIN);
          }}
          action={(json) =>
            dispatch(
              registerTechTeamApi({
                ...json,
                callback: () => {
                  setEmailInitiateModalVisibility(false);
                  setcalendlyModalVisibility(true);
                },
              })
            )
          }
        />
      </Screen>
    </>
  );
};

export default Landing;
